import { type CountryCallingCode, type CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";
import { env as configEnv } from "@/config";

export const validatePhoneNumber = (
    mdn: string | undefined,
    defaultCountry: CountryCode = "US",
): { valid: boolean; number?: string; countryCode?: CountryCallingCode } => {
    if (!mdn) {
        return { valid: false };
    }
    const parsed = mdn.startsWith("+")
        ? parsePhoneNumberFromString(mdn)
        : parsePhoneNumberFromString(mdn, { defaultCountry });
    if (!parsed) {
        return { valid: false };
    }
    const isValid = configEnv.isProdMode ? parsed.isValid() : parsed.isPossible();
    return { valid: isValid, number: parsed.number, countryCode: parsed.countryCallingCode };
};

export const isInternationalCaller = (mdn: string): boolean => {
    const parsed = parsePhoneNumberFromString(mdn);
    if (!parsed) {
        return false;
    }
    return parsed.country !== "US";
};
